<template lang="pug">
  el-form(ref="alertForm" @submit.native.prevent='' label-position="top" :rules="alertRules" :model="alert")

    el-row(:gutter="40")
      el-col(:lg="15")
        el-form-item(label="Subject" prop="subject")
          el-input(v-model.trim="alert.subject" size='large')

        el-form-item(label="Message" prop="message")
          el-input(type='textarea' :autosize="{ minRows: 10, maxRows: 20}" v-model.trim="alert.message")

      el-col( :lg ="9")
        scheduler(v-if='alert' v-model='alert' label='alert' :show-recurring-options='false' @save='onSave'
                  :show-delete='!create' @delete='onDelete' ref='scheduler' :form-submitted='formSubmitted')
          template(slot='middle')
            .side-title Who would you like to see this alert?
            assignee-picker(:assignees.sync='assignees')

          template(slot='saveOptions')
            slot(name='saveOptions')

</template>

<script>
import Scheduler from "@/brapp/components/shared/Scheduler";

import AssigneePicker from "@/brapp/components/shared/AssigneePicker";

export default {
  components: { AssigneePicker, Scheduler },
  model: {
    prop: "alert",
    event: "change"
  },
  props: {
    create: {
      type: Boolean,
      default: true
    },
    alert: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      quickSchedule: "custom",
      formSubmitted: false,
      alertRules: {
        subject: [
          { required: true, message: "Required field", trigger: "blur" }
        ],
        message: [
          { required: true, message: "Required field", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    assignees: {
      get() {
        return {
          users: this.alert.assignees.filter(a => a.user).map(a => a.user),
          appLicenseGroups: this.alert.assignees
            .filter(a => a.appLicenseGroup)
            .map(a => a.appLicenseGroup)
        };
      },
      set(val) {
        this.alert.assignees = val.users
          .map(u => ({ user: u }))
          .concat(val.appLicenseGroups.map(g => ({ appLicenseGroup: g })));
      }
    }
  },
  watch: {
    alert() {
      this.formSubmitted = false;
    }
  },
  methods: {
    onSave() {
      this.formSubmitted = true;
      this.$refs.alertForm.validate(valid => {
        if (this.$refs.scheduler.datesValid) {
          this.$emit("save", { valid });
        } else {
          this.$emit("save", { valid: false });
        }
      });
    },
    onDelete() {
      this.$emit("delete");
    }
  }
};
</script>

<style scoped lang="scss">
.side-title {
  font-family: "gilroyextrabold";
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 0.05em;
  font-size: 14px;
  color: #2c3e50;
  margin: 10px 0 5px 0;
}
</style>
